import React from "react";
import * as R from "ramda";
import { Div, Text2 } from "components/Base";
import { FieldFormatter, FieldEditor } from "ui-kit/FieldTypes/View";
import { noop } from "utils/General";
import { LanguageVariantsButton } from "EventLight/Sessions/Page/View/LanguageVariantUI";

const Field = React.memo(
  ({
    disabled = false,
    field = {},
    values = {},
    onEdit = noop,
    editingFieldId = null,
    setEditingFieldId = noop,
    toggleLanguageModal,
    setSelectedTranslatedFieldId
  }) => {
    const { type = "", id = null, name = "" } = field || {};

    const preventEnter = e => {
      if (e.which === 13) {
        e.preventDefault();
        return onEdit({ id });
      }
      if (e.which === 27) {
        e.preventDefault();
        return setEditingFieldId(null);
      }
      return e;
    };

    return (
      <li>
        <Div
          display="row.flex-start.center"
          p={1}
          onClick={e => e.stopPropagation()}
          style={{
            position: "relative"
          }}
        >
          <Div
            display="row.flex-start.center"
            onClick={() => {
              toggleLanguageModal(true);
              setSelectedTranslatedFieldId(field.id);
            }}
          >
            {R.prop("event_id", field) ? (
              <span
                style={{ marginRight: 5, fontSize: 15 }}
                className="material-icons-outlined"
              >
                event
              </span>
            ) : (
              <span
                style={{ marginRight: 5, fontSize: 15 }}
                className="material-icons-outlined"
              >
                language
              </span>
            )}
          </Div>

          <Text2 display="row.flex-start.center" width={0.3} pt={1}>
            {name}{" "}
            {field.has_translations && (
              <Div ml={1} height={1} display="row.flex-start.center">
                <LanguageVariantsButton
                  tooltip={`Edit language variants for "${field.name}"`}
                />
              </Div>
            )}
          </Text2>
          {!disabled && editingFieldId === id && type !== "signature" ? (
            <Div
              className="field-editor-container"
              width={0.7}
              p={1}
              py={2}
              display="row.flex-start.center"
              bra={1}
              bg={{ default: "white", hover: "neutral0", focus: "neutral0" }}
              onKeyPress={e => preventEnter(e)}
            >
              <FieldEditor materialUI={true} field={field} data={values} />
            </Div>
          ) : (
            <Div
              display="row.flex-start.center"
              width={0.7}
              py={2}
              px={1}
              height={40}
              bg={{ default: "white", hover: "neutral0", focus: "neutral0" }}
              bra={1}
              onClick={disabled ? undefined : () => setEditingFieldId(id)}
              onKeyPress={
                disabled
                  ? undefined
                  : () => {
                      setEditingFieldId(id);
                    }
              }
              tabindex="0"
            >
              <FieldFormatter field={field} data={values} />
            </Div>
          )}
        </Div>
      </li>
    );
  }
);

export default Field;
